import React from 'react';
import {useTranslation} from "react-i18next";
import Graphic from "../../../../../../resources/images/survey.svg";
import EmptyState from "../../../../feeback/State/Empty";

const Empty = () => {
    const {t} = useTranslation();
    return (
        <EmptyState
            title={t('reserve_empty_title')}
            textI18Key='reserve_empty_text'
            graphic={Graphic}
        />
    );

};

export default Empty;